import { render, staticRenderFns } from "./bigImage.vue?vue&type=template&id=6d2e0d5a&scoped=true&"
import script from "./bigImage.vue?vue&type=script&lang=js&"
export * from "./bigImage.vue?vue&type=script&lang=js&"
import style0 from "./bigImage.vue?vue&type=style&index=0&id=6d2e0d5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e0d5a",
  null
  
)

component.options.__file = "bigImage.vue"
export default component.exports